import type { SVGProps } from 'react';
const SvgIconMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path fill="currentColor" d="M12.25 7.25a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5z" />
  </svg>
);
export default SvgIconMinus;
